import { defineAction } from '~/prix'
import { z } from 'zod'
import equipmentDevolutionListAction from './equipmentDevolutionList.action.json' with { type: 'json' }
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import equipmentDevolutionObject from '../equipmentDevolutionObject'

export const equipmentDevolutionExpression = expression(equipmentDevolutionObject.shape)

const equipmentDevolutionListDefinition = defineAction({
  ...equipmentDevolutionListAction,

  input: z.object({
    filter: equipmentDevolutionExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      devolutionDate: 'Data da devolução',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
  }),
  output: z.object({
    items: z.array(equipmentDevolutionObject),
    count: z.number(),
  }),
})

export default equipmentDevolutionListDefinition
